import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const Template = styled.div`
  margin: 24px;
  padding-top: 24px;

  b {
    font-weight: 500;
  }

  span {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 4px;

    ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.primary[100]};
  `}
  }
`;
